import {
    OrganizationCreateForm,
    OrganizationUpdateForm,
    OrganizationData,
    OrganizationListQuery,
    OrganizationStatus,
    OrganizationListResponse,
    OrganizationResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/organization';

export class OrganizationApi {
    public static async create(organization: OrganizationCreateForm): Promise<void> {
        await axios.post(BASE_URL, { organization });
    }

    public static async update(id: string, organization: OrganizationUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { organization });
    }

    public static async updateStatus(id: string, status: OrganizationStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { organization: { status } });
    }

    public static async get(id: string): Promise<OrganizationData> {
        const res = await axios.get<OrganizationResponse>(`${BASE_URL}/${id}`);

        return res.data.organization;
    }

    public static async getList(params: OrganizationListQuery): Promise<OrganizationListResponse> {
        const res = await axios.get<OrganizationListResponse>(BASE_URL, { params });

        return res.data;
    }
}

export { BASE_URL as ORGANIZATION_BASE_URL };
